import React, { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import {
  DownloadExcelAtualizacaoPrecos,
  UploadExcelAtualizacaoPrecos,
} from "../../../providers/EstabelecimentoProvider";

function AtualizacaoExcel() {
  const [showModal, setShowModal] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);

  const handleDownloadPlanilha = async () => {
    await DownloadExcelAtualizacaoPrecos();
  };

  const handleSubmit = async () => {
    const formData = new FormData();
    formData.append("file", selectedFile);
    try {
      await UploadExcelAtualizacaoPrecos(formData);
      toast.success("Estoque atualizado com sucesso!");
      setTimeout(() => {
        setShowModal(false);
        window.location.reload();
      }, 2000);
    } catch (error) {
      setSelectedFile(null);
      if (error.message === "planilha mal preenchida") {
        return toast.error(
          "Erro ao atualizar estoque. A planilha contém erros, por favor corrija e tente novamente."
        );
      }
      return toast.error("Erro ao atualizar estoque");
    }
  };

  return (
    <div>
      <Button onClick={() => setShowModal(true)}>Atualizar por planilha</Button>
      <Modal size="lg" show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton className="modalHeader">
          <Modal.Title>Atualizar estoque por planilha</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h5>
            Para atualizar seu estoque por planilha, realize os seguintes
            passos:
          </h5>
          <p>
            <b>Passo 1:</b> Baixe a planilha modelo clicando no botão abaixo
          </p>
          <Button onClick={handleDownloadPlanilha}>
            Baixar planilha modelo
          </Button>
          <br></br>
          <hr></hr>
          <p>
            <b>Passo 2:</b> Atualize o preço dos produtos que sofreram alteração
          </p>
          <p>OBS: Fique atento as validações dos campos de cada produto</p>
          <hr></hr>
          <Form.Group>
            <Form.Label>
              <b>Passo 3:</b> Submeta a planilha atualizada *
            </Form.Label>
            <Form.Control
              type="file"
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              placeholder="Escolher arquivo"
              onChange={(e) => setSelectedFile(e.target?.files[0])}
            />
          </Form.Group>
          <p>
            Em caso de erro, uma nova planilha contendo o detalhamento será
            baixada automaticamente
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Fechar
          </Button>
          <Button disabled={!selectedFile} onClick={handleSubmit}>
            Atualizar Estoque
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default AtualizacaoExcel;
